import classNames from "classnames"
import styles from "../../../../styles/LandingPage/Patients.module.scss"
import { FC } from "react"
import { SectionProps } from "./SectionType"

const SectionThirteen: FC<SectionProps> = ({ children, backgroundColor = "white", style }) => {
  return (
    <section
      style={{
        backgroundColor: backgroundColor,
        height: "min-content",
        minHeight: "min-content",
        ...style,
      }}
      className={classNames(styles.sectionMedium, styles.sectionThirteen)}
    >
      {children}
    </section>
  )
}

export default SectionThirteen
